/* eslint-disable no-undef */
import * as filestackJS from 'filestack-js';
import toast from './toast';

const { FILESTACK_API } = process.env;
const { FILESTACK_POLICY } = process.env;
const { FILESTACK_SIGNATURE } = process.env;
const { APP_MODE } = process.env;

export const filestack = filestackJS.init(FILESTACK_API);

export const security = {
  policy: FILESTACK_POLICY,
  signature: FILESTACK_SIGNATURE,
};

export const MAX_FILE_SIZE = 10485760; // 10 Mb
export const MAX_PDF_FILE_SIZE = 268435456; // 256 Mb
export const MAX_COVER_FILE_SIZE = 52428800; // 50 Mb

export const filestackImageOptions = {
  accept: 'image/*',
  fromSources: ['local_file_system'],
  maxSize: MAX_FILE_SIZE,
  uploadInBackground: false,
};

export const filestackPDFOptions = {
  accept: '.pdf',
  fromSources: ['local_file_system'],
  maxSize: MAX_PDF_FILE_SIZE,
  uploadInBackground: false,
};

export const filestackCoverOptions = {
  accept: '.pdf',
  fromSources: ['local_file_system'],
  maxSize: MAX_COVER_FILE_SIZE,
  uploadInBackground: false,
};

export const filestackDefaultOptions = {
  accept: ['image/jpeg', 'image/png'],
  acceptFn: (file, options) =>
    options.mimeFromMagicBytes(file.originalFile).then((res) => {
      if (options.acceptMime.length && !options.acceptMime.includes(res)) {
        return Promise.reject(new Error(`Cannot accept file with ${res} MYME type`));
      }
      return Promise.resolve();
    }),
  fromSources: APP_MODE === 'staging' ? ['local_file_system', 'url'] : ['local_file_system'],
  imageMax: [5000, 5000],
  transformations: {
    crop: {
      aspectRatio: 16 / 16,
    },
    circle: false,
    rotate: true,
  },
  cleanupImageExif: {
    keepOrientation: false,
  },
};

export const filestackTransformInit = () => {
  let transformer;

  try {
    transformer = new FilestackTransform(FILESTACK_API, {
      client: {
        security: {
          policy: FILESTACK_POLICY,
          signature: FILESTACK_SIGNATURE,
        },
      },
    });

    transformer.setConfig({
      editor: {
        closeOnSave: true,
      },
      output: {
        blob: true,
        format: 'jpeg',
        name: null,
      },
    });
  } catch (error) {
    toast.error(t('toastMessages.error.needToReloadPage', { ns: i18next.Namespace.COMMON }));
  }

  return transformer;
};
